export default __webpack_public_path__ + "09cfb5f73d4ab801f0e48cc5d8da3695.png";